import CountryPageRenderer from '../components/CountryPageRenderer';
import italyData from '../data/country-pages/italy';

export default function ItalyCountryPage() {
  return <CountryPageRenderer data={italyData} />;
}
